import { DocumentEntity } from '../entities/document-entity';

export default class State {
  loaded = false;

  items: Array<DocumentEntity> = [];
}
